import { createStore } from 'vuex'

const vueStore = createStore({
    state: {
        product: {},
        bikeSerie: {},
        color: '',
        partnumber: {},
        supplementaryItem: {},
        warehouseDealers: [],
        localstockDealers: [],
        dealers: [],
        dealer: {},
        cart: {},
        clientLocation: {},
        shippingOption: {},
        activeImage: {},
        addingProductToCart: false,
        cartInProgress: false,
    },
    mutations: {
        setProduct(state, p) {
            state.product = p
            this.commit('setColor', p.Colors[0])
        },
        setBikeSerie(state, b) {
            state.bikeSerie = b
        },
        setColor(state, c) {
            if (c != undefined) {
                state.color = c;
            }
            this.commit('setPartnumber', null)//reset partnumber
        },
        setPartnumber(state, p) {
            state.partnumber = p
        },
        setSupplementaryItem(state, s) {
            state.supplementaryItem = s
        },
        setDealer(state, dealer) {
            state.dealer = dealer
        },
        setCart(state, c) {
            state.cart = c
        },
        setClientLocation(state, c) {
            state.clientLocation = c
        },
        setWarehouseDealers(state, warehouseDealers) {
            state.warehouseDealers = warehouseDealers
        },
        setLocalStockDealers(state, localstockDealers) {
            state.localstockDealers = localstockDealers
        },
        setDealers(state, dealers) {
            state.dealers = dealers
        },
        setShippingOption(state, p) {
            state.shippingOption = p
        },
        setActiveImage(state, i) {
            state.activeImage = i
        },
        setAddingProductToCart(state, b) {
            state.addingProductToCart = b
        },
        setCartInProgress(state, b) {
            state.cartInProgress = b
        },
    },
});

export default vueStore;